import {
    type AuditTrailFilterValues,
    AuditTrailView,
    adminAuditTrailConfiguration,
} from '@client/components/_business/audit-trail';
import { PageController } from '@client/components/_core/layout/PageController';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { usePathState } from '@client/hooks/navigation/usePathState';
import type { RouterInputs } from '@client/trpc/client';
import { DEFAULT_PAGE_SIZE } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { History } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/admin-console/monitoring/audit-trail')({
    staticData: {
        permissions: ['audit_trail:read'],
        breadcrumb: {
            title: 'Audit trail',
        },
        ui: {
            icon: History,
            title: 'Audit trail',
            subtitle: 'View all administrative actions across the platform',
            widthVariant: 'fullWidth',
            menuDescription: 'Review administrative actions',
        },
    },
    component: AuditTrailPage,
});

type QueryVariables = RouterInputs['admin']['auditTrail']['listAuditTrail'];

function AuditTrailPage() {
    const { trpc } = useTrpc();

    const [filters, setFilters] = useState<AuditTrailFilterValues>({});

    const [queryVariables, setQueryVariables] = usePathState<QueryVariables>('queryVariables', {
        limit: DEFAULT_PAGE_SIZE,
    });

    const { data, refetch, isFetching, error } = trpc.admin.auditTrail.listAuditTrail.useQuery(
        {
            ...queryVariables,
            ...filters,
        },
        { meta: { errorSurface: 'inline' } },
    );

    return (
        <PageController route={Route}>
            <AuditTrailView
                configuration={adminAuditTrailConfiguration}
                data={data?.items}
                total={data?.total}
                error={error}
                isFetching={isFetching}
                queryVariables={queryVariables}
                onFiltersChange={setFilters}
                onQueryVariablesChange={setQueryVariables}
                onRefresh={() => refetch()}
            />
        </PageController>
    );
}
